import toast from "react-hot-toast";
import { CONSTANTES } from "../config/constantes";

function toastErrorPydantic(error) {
    // Iniciando jogando logo o erro no console
    console.error(error);
    
    if (error.response.data.erroCode === 7001) { // Se for cod 7001, foi um erro de validação do pydantic
        const errosDeValidacaoEncontrados = error.response.data.problemas
            .map(problema =>
                `${problema.campo}: ${problema.mensagem}`
            )
            .join(' | ');
        toast.error(errosDeValidacaoEncontrados)
        toast.error(`${error.message}! Consulte os problemas encontrados na notificação abaixo.`);
    } else {
        toast.error(error?.message || `Error inesperado. Peça ajuda ao suporte no email ${CONSTANTES.EMAIL_ADMIN_NTM} informado data e hora do ocorrido.`);
    }
}

export {
    toastErrorPydantic
}